import React from "react";
import "./widget.scss";
import {Link} from "gatsby";
import classNames from "classnames";
import {Title} from "../../elements/Title/title";

export const Widget = props => {

    const classnamesList = classNames(`m-widget--list`, {
        "m-widget--list-big": props.big,
    });

    return (
        <div className="m-widget">
            <Title tag={`h3`} size16 content={props.title} />
            <ul className={classnamesList}>
                {Object.keys(props.list).map((key) => {
                    return(
                        <li>
                            <Link to={`/${props.list[key].url}/`}>{props.list[key].text}</Link>
                        </li>
                    )}
                )}
            </ul>
        </div>
    );
};

export default Widget;